export enum AccountType {
  _LegacyCustomer = 0,
  ServiceProvider = 1,
  LocationOwner = 2,
  Customer = 3,
}
